// config/config.js
export const config = {
  apiBaseUrl: 'https://npm06.com/api',  // Assurez-vous que HTTPS est utilisé
};

export default config;
